exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.channel-icon[data-v-142a7ab4] {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n}\n.description[data-v-142a7ab4] {\n  word-break: break-all;\n}\n", ""]);

// exports
